import React, { useEffect, useState } from "react";

const STORAGE_KEY = "cookie_notice_accepted_v1";

export default function CookieNotice() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const accepted = localStorage.getItem(STORAGE_KEY);
      setVisible(!accepted);
    } catch (e) {
      // If localStorage is blocked, still show the banner
      setVisible(true);
    }
  }, []);

  const accept = (e) => {
    // Make sure nothing else hijacks the click
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    try {
      localStorage.setItem(STORAGE_KEY, "true");
    } catch (err) {
      // ignore (private mode / blocked storage)
    }

    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div style={styles.wrapper}>
      <div style={styles.text}>
  Diese Website verwendet Cookies. Durch die weitere Nutzung der Website stimmen Sie der Verwendung von Cookies sowie unserer Datenschutzerklärung / Impressum zu.
      </div>
      <button onClick={accept} style={styles.button}>
        Akzeptieren
      </button>
    </div>
  );
}

const styles = {
  wrapper: {
    position: "fixed",
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 9999,
    background: "#ddcbb9",
    color: "black",
    zIndex: 2147483647,         
    pointerEvents: "auto",
    padding: "14px 18px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "16px",
    fontSize: "14px"
  },
  text: {
    maxWidth: "900px",
    lineHeight: 1.4,
    fontFamily: "Montserrat-Regular"
  },
  link: {
  },
  button: {
      pointerEvents: "auto",
    border: "none",
    padding: "6px 12px",
    cursor: "pointer",
    borderRadius: "4px",
    fontSize: "13px",
     pointerEvents: "auto",
    whiteSpace: "nowrap",
padding: "0 3%"
  }
};
